export default "__VITE_ASSET__BsNIiR_J__"